import {isClientEntityOperational} from "@common-core/coat-operational-hierarchy-appsync-model";
import {CreatePlanNode, CreatePlanSummary} from "../view-model";

export const summarizePlan = (
  node: CreatePlanNode,
  tenantId: string
): CreatePlanSummary => {
  const operational = isClientEntityOperational(node.source);
  const childSummary = node.children
    .map(child => summarizePlan(child, tenantId))
    .reduce(
      (accumulator, summary) => ({
        creating: [...accumulator.creating, ...summary.creating],
        existing: [...accumulator.existing, ...summary.existing]
      }),
      {
        creating: node.selected && !operational ? [node] : [],
        existing: node.selected && operational ? [node] : []
      }
    );

  return {
    ...childSummary,
    tenantId,
    tenantName: node.source.custName ?? undefined
  };
};
